import api from "./api";
import { APIs } from "../constants/APIConstants";
import { CALL_DATA, GLOBAL_MEETING_DATA } from "../constants/PublicVariables";
import { getActiveRoom } from "../components/Twilio/twilioCallUtility";

export default class EndCallAPIFunction {
    endCall(req) {
        return api.put(APIs.END_CALL.replace("{SessionId}", GLOBAL_MEETING_DATA.sessionId), req);
    }
    disconnectMWebDeepLinkUser() {
        const apiUrl = APIs.DISCONNECT_USER_REMOTELY.replace("{RoomSid}", getActiveRoom()?.sid || CALL_DATA.roomSID).replace(
            "{ParticipantSid}",
            GLOBAL_MEETING_DATA.pid
        );

        return api.delete(apiUrl);
    }
}
